import { memo } from 'react'

import { CloseIcon } from '../../../../components/Icons'

interface IFailGenerationViewProps {
  closePopup: () => void
}

const FailGenerationView: React.FC<IFailGenerationViewProps> = memo(
  ({ closePopup }) => (
    <>
      <div className="px-6 py-8">
        <div className="flex flex-col items-center justify-center h-full">
          <div className="h-12 w-12 rounded-full bg-[#EB5757] text-white flex items-center justify-center">
            <CloseIcon />
          </div>
          <div className="text-white text-xl my-2">Generation failed</div>
          <div className="text-[#F2F2F4] text-sm">
            There was an error generating the companion profile.
          </div>
        </div>
      </div>
      <div className="flex justify-end border-t border-white/10 py-4 px-6">
        <button className="btn btn-primary" onClick={closePopup}>
          Close
        </button>
      </div>
    </>
  ),
)

export { FailGenerationView }
